import type { TourStep } from "../tour-steps";
import { ajudaFinal, area, boasVindas } from "./passos";

/** Acesso pessoal: o seu consultório (se houver) e a visão de todas as organizações em que você
 *  trabalha, sem trocar de uma pra outra. */
export const tourPessoal = (c: boolean, consultorio: boolean): TourStep[] => [
  boasVindas(
    "Seu acesso pessoal",
    "Aqui ficam os seus dados e a visão de todas as clínicas e laboratórios em que você trabalha — sem precisar trocar de organização a toda hora.",
  ),
  area(c, {
    id: "organizacoes",
    menu: "sidebar-organizacoes",
    aba: "aba-organizacoes",
    nome: "Organizações",
    titulo: "Suas organizações",
    texto: "As clínicas e laboratórios em que você está, com um resumo de cada uma. Daqui você cria uma organização nova ou entra em uma delas.",
  }),
  area(c, {
    id: "agenda",
    menu: "sidebar-agenda",
    aba: "aba-agenda",
    nome: "Agenda",
    titulo: "Uma agenda só",
    texto: "Junta as suas consultas de todas as clínicas, com filtro por organização para ver só uma de cada vez.",
  }),
  area(c, {
    id: "pacientes",
    menu: "sidebar-pacientes",
    nome: "Pacientes",
    titulo: "Pacientes de todas as clínicas",
    texto: "A lista junta os pacientes das clínicas em que você pode vê-los. A ficha abre só para leitura, e dá para agendar ou pedir prótese na clínica do paciente sem sair daqui.",
  }),
  ...(consultorio
    ? [
        area(c, {
          id: "protese",
          menu: "sidebar-protese",
          nome: "Prótese",
          titulo: "Seus pedidos de prótese",
          texto: "Os pedidos do seu consultório aos laboratórios parceiros, com prazo e status.",
        }),
      ]
    : []),
  area(c, {
    id: "conta",
    menu: "sidebar-conta",
    nome: "Minha conta",
    noCelular: "toque na sua foto, no alto, e depois em Minha conta",
    titulo: "Minha conta",
    texto: "Seus dados, CRO e especialidades, senha e PIN, notificações e privacidade.",
  }),
  ajudaFinal(),
];
